import axios from "../axios";
import {
    GET_ALL_USERS,
    GET_USER_DETAILS,
    UPDATE_USER,
    ADD_USER,
    DELETE_USER_DETAILS,
    DELETE_USER,
    USERS_LOADING,
    GET_CUSTOMER_DETAILS, ADD_CUSTOMER
} from "./types";
import {tokenConfig} from "./authActions";
import {returnErrors} from "./errorActions";

export const getAllUsers = () => dispatch => {
    dispatch(setUsersLoading());
    axios
        .get('/api/users')
        .then(res => {
            let data = res.data;
            for(let i = 0; i< res.data.length; i++){
                data[i] = {
                    ...data[i],
                    id: i+1,
                }
            }
            dispatch({
                type: GET_ALL_USERS,
                payload: {
                    data: data,
                    errorMessage: false
                }
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_USERS,
                payload: {
                    data: false,
                    errorMessage: err?.message
                }
            })
        })
};
export const getUserDetails = (id) => {
    return (dispatch) => {
        axios
            .get('/api/users/' + id)
            .then(function (response){
                dispatch({
                    type: GET_USER_DETAILS,
                    payload: {
                        data: response?.data,
                        errorMessage: false,
                    }
                })
            })
            .catch(function (error) {
                dispatch({
                    type: GET_USER_DETAILS,
                    payload: {
                        data: false,
                        errorMessage: error?.message,
                    }
                })
            })
    }
}
/*export const getAllUsers = () => dispatch => {
    dispatch(setUsersLoading());
    axios
        .get('/api/tasks')
        .then(res =>
            dispatch({
                type: GET_ALL_USERS,
                payload: res.data
            }))
        .catch(err => dispatch(returnErrors(err.response.data, err.response.status)))
};*/

export const addUser = (data) => {
    return (dispatch, getState) => {
        axios
            .post('/api/users', data, tokenConfig(getState))
            .then(function (response) {
                dispatch({
                    type: ADD_USER,
                    payload: {
                        data: response?.data,
                        errorMessage: false
                    }
                })
            }).catch(function (error) {
            dispatch({
                type: ADD_USER,
                payload: {
                    data: false,
                    errorMessage: error?.response?.data?.msg
                }
            })
        });
    };
}

export const updateUser = (user, id) => {
    return (dispatch, getState) => {
        axios
            .put("/api/users/"+id, user, tokenConfig(getState))
            .then(function (response) {
                dispatch({
                    type: UPDATE_USER,
                    payload: {
                        data: response?.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: UPDATE_USER,
                    payload: {
                        data: false,
                        errorMessage: error?.message
                    },
                });
            })
    };
}

export const deleteDataUser = () => {
    return (dispatch) => {
        dispatch({
            type: GET_USER_DETAILS,
            payload: {
                data: false,
                errorMessage: false,
            }
        });

        dispatch({
            type: ADD_USER,
            payload: {
                data: false,
                errorMessage: false,
            }
        });
    }
}

export const deleteUser = id => (dispatch, getState) => {
    dispatch(setUsersLoading());
    axios
        .delete(`/api/users/${id}`, tokenConfig(getState))
        .then(res =>
            dispatch({
                type: DELETE_USER,
                payload: id
            })
        ).catch(err => dispatch(returnErrors(err?.response?.data, err?.response?.status)))
};


export const setUsersLoading = () => {
    return {
        type: USERS_LOADING,
    };
};
